module.exports = __webpack_public_path__ + "img/chinesecompany101.9fcba85c.png";